<template>
<div>
  <section class="community-section pc-community-partner" id="community">
    <div class="join-community">
      <header class="join-com-title section-title-wrapper">
        <div class="title-left">
          <h1 class="section-title" v-text="$t('home.join_us_title')"></h1>
          <h2 class="section-sub-title" v-text="$t('home.join_us_sub_title')"></h2>
        </div>
      </header>
      <div class="join-com-content">
        <div class="join-wechat-wrapper" @click="showQrCode">
          <div class="join-wechat join-img">
            <img src="../../../assets/img/join/join_wechat.png" alt class="join-wechat-img" />
            <div  class="join-text" v-text="$t('join.wechat')"></div>
          </div>
          <div class="join-wechat-active join-img">
            <img src="../../../assets/img/join/join_wechat_active.png" alt class="join-wechat-active-img" />
            <div  class="join-text active" v-text="$t('join.wechat')"></div>
          </div>
        </div>
        <a class="join-tel-wrapper" href="https://t.me/MixMarvelGlobal" target="_blank">
          <div class="join-tel join-img">
            <img src="../../../assets/img/join/join_Telegram.png" alt class="join-tel-img" />
            <div  class="join-text" v-text="$t('join.telegram')"></div>
          </div>
          <div class="join-tel-active join-img">
            <img src="../../../assets/img/join/join_Telegram_active.png" alt class="join-tel-active-img" />
            <div  class="join-text active" v-text="$t('join.telegram')"></div>
          </div>
        </a>
        <a class="join-kakao-wrapper" href="https://open.kakao.com/o/gmNbUgub" target="_blank">
          <div class="join-kakao join-img">
          <img src="../../../assets/img/join/join_kakao.png" alt class="join-kakao-img" />
            <div  class="join-text" v-text="$t('join.kakao')"></div>
          </div>
          <div class="join-kakao-active join-img">
          <img src="../../../assets/img/join/join_kakao_active.png" alt class="join-kakao-active-img" />
            <div  class="join-text active" v-text="$t('join.kakao')"></div>
          </div>
        </a>
      </div>
    </div>
    <div class="partners">
      <header class="partners-title section-title-wrapper">
        <div class="title-left">
          <h1 class="section-title" v-text="$t('home.partners_title')"></h1>
          <h2 class="section-sub-title" v-text="$t('home.partners_sub_title')">Strategic partners</h2>
        </div>
      </header>
      <div class="partner-container">
        <div class="swiper-container partner-swiper">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="item in partners"
              :key="item.id"
              :title="item.title"
              :style="'background-image:url('+item.logo+')'"
            >
              <a :href="item.href" target="_blank" rel="noopener noreferrer" class="partner-link"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="wap-community-partner" id="wap_community">
    <div class="community-container">
      <header class="wap-title-wrapper">
        <div class="wap-title-left">
          <div
            class="wap-section-title"
            v-html="$t('home.join_us_title').replace('，','<br>').replace(',','<br>')"
          ></div>
          <div class="wap-section-sub-title" v-text="$t('home.join_us_sub_title')"></div>
        </div>
      </header>
      <div class="community-content">
        <div class="join-wrapper">
          <div class="join-img join-wechat" @click="showQrCode">
            <div class="join-text" v-text="$t('join.wechat')"></div>
          </div>
          <a class="join-img join-tel" href="https://t.me/MixMarvelGlobal" target="_blank">
            <div class="join-text" v-text="$t('join.telegram')"></div>
          </a>
          <a class="join-img join-kakao" href="https://open.kakao.com/o/gmNbUgub" target="_blank">
            <div class="join-text" v-text="$t('join.kakao')"></div>
          </a>
        </div>
      </div>
    </div>
    <div class="partner-container">
      <header class="wap-title-wrapper">
        <div class="wap-title-left">
          <div class="wap-section-title" v-text="$t('home.partners_title')"></div>
          <div class="wap-section-sub-title" v-text="$t('home.partners_sub_title')"></div>
        </div>
      </header>
      <div class="partner-content">
        <div class="swiper-container swiper-container-partner">
          <div class="swiper-wrapper">
            <div
              class="swiper-slide"
              v-for="item in partners"
              :key="item.id"
              :title="item.title"
              :style="'background-image:url('+item.logo+')'"
            >
              <a class="partner-item-link" :href="item.href"></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { getPartnerList } from "../../../request/api";
import { animationScroll } from "@/assets/js/common";

export default {
  data() {
    return {
      activeLogoIndex: "",
      partners: []
    };
  },
  methods: {
    activeLogo(index) {
      this.activeLogoIndex = index;
    },
    unactiveLogo() {
      this.activeLogoIndex = "";
    },
    showQrCode() {
      this.$emit("func", true);
    },
    init() {
      this.getPartners();
    },
    getPartners() {
      var that = this;
      var localPartnerList = localStorage.getItem("partnerList");
      if (localPartnerList && localPartnerList != "undefined") {
        //先读取缓存的banner图
        that.partners = JSON.parse(localPartnerList);
      }
      getPartnerList({})
        .then(res => {
          if (res.success) {
            that.partners = res.partnerList;
            localStorage.setItem(
              "partnerList",
              JSON.stringify(res.partnerList)
            );
          }
          that.$nextTick(function() {
            that.initSwiper();
          });
        })
        .catch(err => {
          console.log(err);
        });
    },
    initSwiper() {
      var partner_swiper = new Swiper(".partner-swiper", {
        autoplay: {
          delay: 0
        },
        loop: true,
        speed: 2000,
        slidesPerView: 6,
        spaceBetween: 30,
        freeMode: true,
        freeModeSticky: false,
        observer: true,
        waitForTransition: false,
        on: {
          resize: function() {
            //窗口变化了
            partner_swiper.update();
          }
        }
      });
      partner_swiper.el.onmouseover = function() {
        partner_swiper.autoplay.stop();
      };
      partner_swiper.el.onmouseout = function() {
        partner_swiper.autoplay.start();
      };

      var wapSwiperPlan = new Swiper(".swiper-container-partner", {
        autoplay:true,
        loop: true,
        slidesPerView: 4,
        spaceBetween: 30,
        watchSlidesProgress: true,
        observer: true,
      });
    }
  },
  mounted() {
    this.init();
    animationScroll($(".community-section"));
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pc/index/communityPartnerSection.vue